import { render } from "./AddWatch.vue?vue&type=template&id=2c792932&scoped=true&lang=pug"
import script from "./AddWatch.vue?vue&type=script&lang=js"
export * from "./AddWatch.vue?vue&type=script&lang=js"

import "./AddWatch.vue?vue&type=style&index=0&id=2c792932&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c792932"]])

export default __exports__